import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getMe } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ authed: null, user: null });
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const user = await getMe();
        if (active) setState({ authed: true, user });
      } catch (_e) {
        if (active) {
          setState({ authed: false, user: null });
          navigate("/", { replace: true });
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [navigate]);

  if (state.authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="font-display text-2xl uppercase">Cargando...</div>
      </div>
    );
  }
  if (!state.authed) return null;
  return React.cloneElement(children, { user: state.user });
}
